<template>

  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Trainee ID eingeben</p>
        <button class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <div class="control">
            <input class="input is-primary" v-model="traineeId" type="text" placeholder="Hier ihre Trainee ID eingeben">
          </div>
        </div>
        <p>
          Wenn Sie keine Trainee ID haben melden sie sich bei Boas@Enkler.OnMicrosoft.com
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" v-on:click="set">Los geht's !</button>
      </footer>
    </div>
  </div>
</template>

<script>
  import learnApiClient from '../LearnApiClient';

  export default {
    name: "setTrainee",
    data() {

      return {
        traineeId: ""
      }
    },
    methods: {

      set: async function () {
        await learnApiClient.existsTrainee(this.traineeId);
        this.$store.commit("setTrainee", this.traineeId);
        this.$router.push({name: "hub"})
      }
    },
    async mounted() {
      var id = this.$router.currentRoute.params.id;

      if(id)
      {
        this.$store.commit("setTrainee", id);
        this.$router.push({name: "hub"})
      }
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/trainee/setTrainee.vue